import React from 'react';
import { useTranslation } from 'react-i18next';

import { PrimaryHeader } from '@repo/ui/components/typography/Headers';
import { Paragraph } from '@repo/ui/components/typography/Content';
import FocusedExperience from '@/components/FocusedExperience';
import Link from '@repo/ui/components/buttons/Link';
import { usePageTitle } from '@/utils/Hooks';

export default function PageNotFound() {
  const { t } = useTranslation(['common']);
  usePageTitle(t('common:labels.pageNotFound'));

  return (
    <FocusedExperience>
      <PrimaryHeader>{t('common:labels.pageNotFound')}</PrimaryHeader>
      <Paragraph>{t('common:labels.pageNotFoundDescription')}</Paragraph>
      <Link to={{ pathname: `/dashboard` }}>{t('common:actions.backToFeed')}</Link>
    </FocusedExperience>
  );
}
